
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator"

// @ts-ignore
import speakeasy from "speakeasy"

import api from "@/services/api"
import { AuthSetup } from "@/types/user"

import MFASetup from "./MFASetup.vue"

@Component({
	components: {
		"mfa-setup": MFASetup
	}
})
export default class LoginMfaSetup extends Vue {
	@Ref()
	authCodeTextBox!: HTMLInputElement

	@Prop({ default: false })
	isSystem!: boolean

	@Prop({ default: null })
	tenantName!: string | null

	private newAuthDetails: AuthSetup | null = null
	private localAuthCode: string | null = null
	private submitting: boolean = false
	private error: any = null

	private get codeTenantName (): string | null {
		return this.isSystem ? "System Admin" : this.tenantName
	}

	mounted () {
		// setTimeout(() => {
		// 	this.authCodeTextBox.focus()
		// }, 100)
	}

	async setMfa () {
		if (!this.newAuthDetails) {
			return
		}

		try {
			if (this.isSystem) {
				await api.setSystemMfa(this.newAuthDetails)
			} else {
				await api.setMfa(this.newAuthDetails)
			}

			this.$emit("set")
		} catch (err) {
			this.error = err
		}
	}
}

